import * as React from "react";
import { Box, Button, Card, Stack, Typography } from "@mui/joy";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { createAdminReadingNote } from "../api";
import AdminReadingNoteForm, { ReadingNoteFormValues } from "../components/Admin/AdminReadingNoteForm";
import PageHero from "../components/common/PageHero";

export default function AdminReadingNoteCreatePage() {
  const navigate = useNavigate();
  const [saving, setSaving] = React.useState(false);

  const handleCreate = async (data: ReadingNoteFormValues) => {
    if (saving) return;
    setSaving(true);
    try {
      const created = await createAdminReadingNote(data);
      if (created?.id) {
        navigate(`/articles/${created.id}`);
      } else {
        navigate("/articles");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <PageHero
        eyebrow="Sacred study"
        title="Write a new article"
        description="Offer a devotional reflection that will uplift seekers exploring the reading library."
        actions={
          <Button
            component={RouterLink}
            to="/articles"
            variant="outlined"
            color="neutral"
            startDecorator={<ArrowBackRoundedIcon />}
          >
            Back to library
          </Button>
        }
      />

      <Card
        variant="outlined"
        sx={{
          borderRadius: "xl",
          p: { xs: 2.5, md: 3 },
          gap: 2.5,
        }}
      >
        <Stack spacing={0.75}>
          <Typography level="title-md" sx={{ fontWeight: 700 }}>
            Share today’s inspiration
          </Typography>
          <Typography level="body-sm" sx={{ color: "text.secondary", maxWidth: 560 }}>
            Chronicle realizations, share festival highlights, or capture guidance from the acharyas. Devotees will discover
            this reflection in the articles hub and pinned reading notes.
          </Typography>
        </Stack>

        <AdminReadingNoteForm
          onSubmit={handleCreate}
          submitLabel="Publish article"
          loading={saving}
        />
      </Card>
    </Box>
  );
}
